import React from 'react'
import NFLTemplate from 'src/components/page/nfl'
import { teamIds } from 'src/constants/personalizationIds'
export default (props) => (
  <NFLTemplate {...props} team="Cleveland Browns" teamShort="Browns" teamId={teamIds['Cleveland Browns']} />
)
